import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const HYGIENE_PERFORMANCE_FILTERS = REPORTS_DEFAULT_FILTERS

export const HYGIENE_PERFORMANCE_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  format: 'number' | 'decimal' | 'percent'
}> = [
  {
    id: 'hygiene-visits',
    title: 'Hygiene Visits',
    footer: 'Excl. cancelled / no-show',
    format: 'number',
  },
  {
    id: 'hygiene-openings-total',
    title: 'Hygiene Openings (Total)',
    footer: 'Total capacity slots',
    format: 'number',
  },
  {
    id: 'hygiene-utilization',
    title: 'Hygiene Utilization %',
    footer: 'Booked / capacity',
    format: 'percent',
  },
  // TODO: unhide Recall Compliance and Hygiene Reactivation when ready for implementation
  // {
  //   id: 'recall-compliance',
  //   title: 'Recall Compliance %',
  //   footer: 'Scheduled / due',
  //   format: 'percent',
  // },
  // {
  //   id: 'hygiene-reactivation',
  //   title: 'Hygiene Reactivation %',
  //   footer: 'Success rate',
  //   format: 'percent',
  // },
]

/** @deprecated Use HYGIENE_PERFORMANCE_KPI_DEFINITIONS with live API values */
export const HYGIENE_PERFORMANCE_KPI_METRICS =
  HYGIENE_PERFORMANCE_KPI_DEFINITIONS.map((def) => ({
    id: def.id,
    title: def.title,
    footer: def.footer,
    value: '—',
  }))

export type HygieneOpeningsRow = {
  month: string
  /** Average hygiene openings per day. */
  openings: number
}

/** @deprecated Preview/PDF mock only */
export const HYGIENE_OPENINGS_DATA: HygieneOpeningsRow[] = [
  { month: 'Dec', openings: 6.3 },
  { month: 'Jan', openings: 5.6 },
  { month: 'Feb', openings: 5.2 },
  { month: 'Mar', openings: 5.6 },
]

export type HygieneUtilizationRow = {
  month: string
  /** Utilization as a percentage (0–100). */
  rate: number
}

/** @deprecated Preview/PDF mock only */
export const HYGIENE_UTILIZATION_DATA: HygieneUtilizationRow[] = [
  { month: 'Dec', rate: 80.4 },
  { month: 'Jan', rate: 82.4 },
  { month: 'Feb', rate: 83.8 },
  { month: 'Mar', rate: 82.5 },
]

export type RecallComplianceRow = {
  month: string
  /** Compliance as a percentage (0–100). */
  rate: number
}

/** @deprecated Preview/PDF mock only */
export const RECALL_COMPLIANCE_DATA: RecallComplianceRow[] = [
  { month: 'Dec', rate: 69.2 },
  { month: 'Jan', rate: 68.2 },
  { month: 'Feb', rate: 66.6 },
  { month: 'Mar', rate: 66.7 },
]

export type HygieneReactivationRow = {
  month: string
  /** Reactivation success rate as a percentage (0–100). */
  rate: number
}

/** @deprecated Preview/PDF mock only */
export const HYGIENE_REACTIVATION_DATA: HygieneReactivationRow[] = [
  { month: 'Dec', rate: 18.2 },
  { month: 'Jan', rate: 20.5 },
  { month: 'Feb', rate: 19.3 },
  { month: 'Mar', rate: 18.5 },
]
